import { useState } from 'react'
import { View } from 'react-native'
import cn from '@ui/utils/cn'

import Select from '@ui/forms/Select'
import { ControlledCheckbox } from '@ui/forms/Checkbox'

import InputAction from '@ui/forms/Input/InputAction'
import Page from '@shell/Page'
import InputDate from '@ui/forms/Date/InputDate'
import InputsSection from '@ui/forms/InputsSection'
import { colors } from '@ui/colors'
import Typography from '@ui/typography'
import Input from '@ui/forms/Input'

const options = [
  {
    label: 'Option 1',
    value: 'option1',
  },
  {
    label: 'Option 2',
    value: 'option2',
  },
  {
    label: 'Option 3',
    value: 'option3',
  },
]

const action = <InputAction icon="qr-code" onPress={console.log} />

export default function DevFormsPage() {
  const [currentBg, setBG] = useState('bg-white')
  const [editableDate, setEditableDate] = useState<Date | undefined>(
    new Date('2024-06-15')
  )

  return (
    <Page className={cn('pb-96', currentBg)}>
      <View className="gap-8 p-16">
        <Select label="Label" options={[]} onChange={() => ({})} />
        <Select
          label="Label"
          options={[]}
          onChange={() => ({})}
          errorMessage="error"
        />
        <Select
          placeholder="Background Color"
          label="Background"
          icon="menu-deep"
          onChange={setBG}
          value={currentBg}
          options={[
            {
              label: 'white',
              value: 'bg-white',
            },
            {
              label: 'black/10',
              value: 'bg-black/10',
            },
            {
              label: 'black/25',
              value: 'bg-black/25',
            },
            {
              label: 'black/75',
              value: 'bg-black/75',
            },
            {
              label: 'black',
              value: 'bg-black',
            },
          ]}
        />

        <ControlledCheckbox label="Checkbox" />
        <ControlledCheckbox
          label="Privacy Policy for Installment Purchase"
          desc="As a customer, by signing, you agree to the transfer of your data for the purpose of processing the financing and conducting a credit check. Please note that no SCHUFA entry will be made upon signing. If two monthly payments are overdue, the full remaining amount becomes immediately due. Direct debit withdrawals will take place on the 28th of each current month. All information on data protection can be found at: URL"
          error
        />
        <ControlledCheckbox
          disabled
          defaultValue={false}
          label="Disabled Checkbox"
        />

        <ControlledCheckbox
          disabled
          defaultValue={true}
          label="Disabled Checkbox Checked"
        />
        <Input placeholder="Placeholder" />
        <Select
          placeholder="Placeholder"
          onChange={console.log}
          options={options}
          value={options[0].value}
        />
        <Input placeholder="Placeholder" icon="info-circle" />
        <Select
          placeholder="Placeholder"
          icon="info-circle"
          onChange={console.log}
          options={options}
        />
        <Input placeholder="Placeholder" label="Label" />
        <Select
          placeholder="Placeholder"
          label="Label"
          onChange={console.log}
          options={options}
        />
        <Input placeholder="Placeholder" label="Label" icon="info-circle" />
        <Select
          placeholder="Placeholder"
          label="Label"
          icon="info-circle"
          onChange={console.log}
          options={options}
        />
        <Input
          placeholder="Placeholder"
          label="Label"
          icon="info-circle"
          action={action}
        />
        <Input
          placeholder="Placeholder"
          errorMessage="Invalid value"
          label="Input"
          icon="info-circle"
          action={action}
        />
        <Input
          placeholder="Placeholder"
          successMessage="Success"
          label="Input"
          icon="info-circle"
          action={action}
        />
        <Select
          placeholder="Placeholder"
          errorMessage="Invalid value"
          label="Select"
          icon="info-circle"
          onChange={console.log}
          options={options}
        />
        <Select
          placeholder="Placeholder"
          successMessage="Success"
          label="Select"
          icon="info-circle"
          onChange={console.log}
          options={options}
        />
        <Input placeholder="Placeholder" label="Light" />
        <Input
          icon="info-circle"
          placeholder="Disabled"
          label="Light"
          disabled
        />
        <Input
          icon="info-circle"
          value="Disabled value"
          disabled
          label="Light"
        />
        <Select
          placeholder="Placeholder"
          label="Light"
          options={options}
          onChange={console.log}
        />
        <InputDate placeholder="Date" label="Date" />
        <InputDate
          placeholder="Date with Edit"
          label="Date with Edit"
          enableEdit={true}
          value="2024-01-15"
        />
        <InputDate
          placeholder="Date with Edit and Min/Max"
          label="Date with Edit and Min/Max"
          enableEdit={true}
          min={new Date('2020-01-01')}
          max={new Date('2030-12-31')}
        />
        <InputDate
          placeholder="Interactive Date with Edit"
          label="Interactive Date with Edit"
          enableEdit={true}
          value={editableDate?.toISOString().split('T')[0]}
          onChange={(date) => {
            console.log('Date changed:', date)
            setEditableDate(date)
          }}
        />
        {editableDate && (
          <Typography variant="SM" className="color-desc">
            Selected date: {editableDate.toLocaleDateString()}
          </Typography>
        )}
        <InputsSection
          title="Input Section"
          statusProps={{
            text: 'Group',
            colors: {
              front: colors.text50,
              back: colors.text10,
            },
          }}
        >
          <Input label="Input" placeholder="Placeholder" />
        </InputsSection>
        <InputsSection
          row
          title="Inputs Section Sides"
          statusProps={{
            text: 'Group',
            colors: {
              front: colors.text50,
              back: colors.text10,
            },
          }}
        >
          <Input label="Right" placeholder="Value" className="flex-1" />
          <Input label="Left" placeholder="Value" className="flex-1" />
        </InputsSection>
        <InputsSection group title="Group" desc="Description">
          <InputsSection inner row title="Input1">
            <Input label="Right" placeholder="Value" className="flex-1" />
            <Input label="Left" placeholder="Value" className="flex-1" />
          </InputsSection>
          <InputsSection inner row title="Input1">
            <Input label="Right" placeholder="Value" className="flex-1" />
            <Input label="Left" placeholder="Value" className="flex-1" />
          </InputsSection>
        </InputsSection>
        <Input
          required
          label="Default"
          labelVariant="top"
          placeholder="Label Top"
        />
        <Input
          required
          successMessage="Success"
          label="Success"
          labelVariant="top"
          placeholder="Label Top"
        />
        <Input
          required
          errorMessage="Error"
          label="Error"
          labelVariant="top"
          placeholder="Label Top"
        />
        <Select
          required
          label="Select"
          labelVariant="top"
          placeholder="Label Top"
          options={options}
          onChange={console.log}
        />
        <InputDate
          required
          label="Date"
          labelVariant="top"
          placeholder="Label Top"
          value="2024-01-15"
        />
      </View>
    </Page>
  )
}
